import React, { useRef } from 'react';
import Node from './Node';
import Connector from './Connector';
import '../styles/canvas.css';

const Canvas = ({
  nodes,
  connectors,
  zoom,
  pan,
  onZoom,
  onPanStart,
  onPan,
  onSelect,
  onDragStart,
  onDrag,
  selectedItems,
  collaborators,
  selectedTool,
  setNodes
}) => {
  const canvasRef = useRef(null);

  const handleWheel = (e) => {
    e.preventDefault();
    const delta = e.deltaY > 0 ? -1 : 1;
    onZoom(delta);
  };

  const handleMouseDown = (e) => {
    if (e.button === 1 || (e.button === 0 && e.ctrlKey)) {
      onPanStart(e);
      return;
    }

    if (selectedTool !== 'select' && e.button === 0) {
      const rect = canvasRef.current.getBoundingClientRect();
      const x = (e.clientX - rect.left - pan.x * zoom) / zoom;
      const y = (e.clientY - rect.top - pan.y * zoom) / zoom;
      
      const newNode = {
        id: `node-${Date.now()}`,
        type: selectedTool,
        x,
        y,
        width: selectedTool === 'text' ? 150 : 100,
        height: selectedTool === 'text' ? 40 : 80,
        content: selectedTool === 'text' ? 'Nuevo texto' : '',
        color: '#3498db'
      };
      
      setNodes(prev => [...prev, newNode]);
      onSelect(newNode.id, false);
    }
  };

  const handleMouseMove = (e) => {
    if (e.buttons === 1 && e.ctrlKey) {
      onPan(e);
    }
  };

  return (
    <div
      ref={canvasRef}
      className="canvas-container"
      onWheel={handleWheel}
      onMouseDown={handleMouseDown}
      onMouseMove={handleMouseMove}
      onClick={(e) => e.target === canvasRef.current && onSelect(null)}
    >
      <div
        className="canvas-content"
        style={{
          transform: `scale(${zoom}) translate(${pan.x}px, ${pan.y}px)`,
          width: '10000px',
          height: '10000px'
        }}
      >
        {connectors.map(connector => (
          <Connector key={connector.id} {...connector} />
        ))}
        {nodes.map(node => (
          <Node
            key={node.id}
            {...node}
            zoom={zoom}
            isSelected={selectedItems.includes(node.id)}
            onSelect={onSelect}
            onDragStart={onDragStart}
            onDrag={onDrag}
          />
        ))}
      </div>
    </div>
  );
};

export default Canvas;